import * as types from "../../constants";
import { decryptPatientsData } from '../../utils/index.jsx';
import { GROUPED_INVESTIGATION_UUID, groupedInvestigations } from "../../constants/grouped";
/**
 * Reducer that saves all the investigations loaded
 * @constructor
 * @param {boolean} state 
 */

 const initialState = {
    data: null,
    currentInvestigation:null,
    // Grouped ("All my investigations") view. When true, currentInvestigation still
    // holds a real investigation; this flag tells the patient list to aggregate.
    groupedMode: false,
    loading: 0,
    error: null
}
 
export default function reducer(state = initialState, action){
    
    let newState = { ...state};
    switch(action.type){
        case types.FETCH_INVESTIGATIONS_SUCCESS:
            newState.data = action.investigations;       
            newState.loading = 0; 
            newState.error = null;   
            return newState;
        case types.FETCH_INVESTIGATIONS_LOADING:
            newState.loading = 1;   
            newState.error = null;                           
            return newState;
        case types.SELECT_INVESTIGATION: {
            if(action.selectedInvestigation === GROUPED_INVESTIGATION_UUID){
                // Grouped mode: keep a real investigation as currentInvestigation (the
                // first one the researcher holds the permission in) so every screen/hook
                // that reads currentInvestigation keeps working; groupedMode drives the
                // aggregated patient list.
                const grouped = groupedInvestigations(newState.data);
                newState.groupedMode = true;
                newState.currentInvestigation = grouped[0] || newState.data[0] || null;
                return newState;
            }
            const indexInvestigation = newState.data.findIndex((investigation) => investigation.uuid === action.selectedInvestigation);
            newState.currentInvestigation = newState.data[indexInvestigation];
            // keepGrouped: drilling from the grouped list into a patient's real
            // investigation must not leave grouped mode (so Back returns to the list).
            if(!action.keepGrouped){
                newState.groupedMode = false;
            }
            return newState;
        }
        case types.UPDATE_BILLING_INFO_SUCCESS:
            newState.currentInvestigation.billingInfo = action.billingInfo;
            newState.loading = 0; 
            newState.error = null; 
            return newState;
        case types.FETCH_INVESTIGATIONS_DECRYPTING_DATA:
            newState.loading = 2; 
            newState.error = null; 
            return newState;
        case types.UPDATING_PATIENTS_LOADING:
            newState.loading = 3; 
            newState.error = null; 
            return newState;
        case types.FETCH_NEW_PATIENTS_SUCCESS:
            newState.loading = 0; 
            newState.error = null; 
            return newState;
        case types.INITIALIZE_INVESTIGATIONS:
            newState.data = action.payload.investigations;
            newState.currentInvestigation = action.payload.investigations[0];
            newState.loading = 0; 
            newState.error = null; 
            return newState;   
        case types.AUTH_SIGN_OUT:
            localStorage.removeItem("rawKeyInvestigation");
            newState = {...initialState};
            return newState;
        default:
            return state;
    }
}